// extracted by mini-css-extract-plugin
export default {"noAccessContainer":"TranscriptsPermissionContext__noAccessContainer___LISJs"};